module.exports = __webpack_public_path__ + "img/reference-vfm.85a6f7d7.webp";